var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMicOnRemote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9775 16.9326C16.4898 16.9326 17.7015 15.7118 17.7015 14.1995L17.7106 8.73316C17.7106 7.22081 16.4898 6 14.9775 6C13.4651 6 12.2443 7.22081 12.2443 8.73316V14.1995C12.2443 15.7118 13.4651 16.9326 14.9775 16.9326ZM19.806 14.1995C19.806 16.9326 17.492 18.8458 14.9775 18.8458C12.463 18.8458 10.1489 16.9326 10.1489 14.1995H8.6001C8.6001 17.3062 11.0782 19.8753 14.0664 20.3217V23.31H15.8885V20.3217C18.8768 19.8844 21.3548 17.3153 21.3548 14.1995H19.806Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMicOnRemote);
export default __webpack_public_path__ + "static/media/ic-mic-on-remote.afdb16722da286b986d66894b33f9623.svg";
export { ForwardRef as ReactComponent };